import { AxiosRequestConfig } from 'axios';
import { createAsyncAction } from 'typesafe-actions';
import { ApiError } from '@types';
import { config } from '../../config';

export const fetchAutoPayStatus = createAsyncAction(
    [
        'autoPayStatus/FETCH_AUTO_PAY_STATUS_REQUEST',
        (accountNumber: string) => {
            return {
                url: `${config.env('disasterRecoveryUrl')}/api/v1/selfserv/loans/${accountNumber}/payments/pending-payments`,
                method: 'get'
            } as AxiosRequestConfig;
        }
    ],
    ['autoPayStatus/FETCH_AUTO_PAY_STATUS_SUCCESS', (response: any) => response],
    ['autoPayStatus/FETCH_AUTO_PAY_STATUS_FAILURE', (error: ApiError) => error],
    'autoPayStatus/FETCH_AUTO_PAY_STATUS_CANCEL'
)();
